import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import _ from "lodash";
import { twMerge } from "tailwind-merge";
import { computed, useAttrs, inject } from "vue";
import { ProvideFormInline } from "./FormInline.vue";


const __default__ = {
  inheritAttrs: false,
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'FormLabel',
  setup(__props) {

const attrs = useAttrs();

const formInline = inject<ProvideFormInline>("formInline", false);

const computedClass = computed(() =>
  twMerge([
    "inline-block mb-2",
    formInline && "mb-2 sm:mb-0 sm:mr-5 sm:text-right",
    typeof attrs.class === "string" && attrs.class,
  ])
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _mergeProps({ class: _unref(computedClass) }, _unref(_).omit(_unref(attrs), 'class')), [
    _renderSlot(_ctx.$slots, "default")
  ], 16))
}
}

})